const formatDate = date => {
  const mm = (date.getMonth() < 9 ? "0" : "") + (date.getMonth() + 1);
  const dd = (date.getDate() < 10 ? "0" : "") + date.getDate();
  return dd + "/" + mm + "/" + date.getFullYear();
};
export default formatDate;
